import AboutHero from "./AboutHero";
import AboutJivi from "./AboutJivi";
import AboutStatements from "./AboutStatements";
import AboutCoreValues from "./AboutCoreValues";

const About = () => {
    return (
        <>
        <AboutHero />
        <AboutJivi />
        <AboutStatements />
        <AboutCoreValues />
        </>
    );
};

export default About;